module.exports = {"A_18":"18","A_60":"60","A_40":"40","A_16":"16","A_22":"22","A_30":"30","A_24":"24","A_36":"36","A_20":"20","A_26":"26","A_32":"32","A_28":"28"}


//////////////////
// WEBPACK FOOTER
// ./res/fontSize.json
// module id = 6
// module chunks = 0